import * as React from 'react';
import type AppError from '../../../lib/AppError';
import HybridLink from '../HybridLink/HybridLink';
import cn from '~modules/cn';
import Styles from './error-details-view.module.scss';

type Props = {
    error: AppError;
    transparent?: boolean;
    className?: string;
};

const ErrorDetailsView = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
    <div className={cn(props.className)}>
        <div className={cn(Styles.wrapper, { [Styles.transparent]: props.transparent })} ref={ref}>
            <div className={Styles.contents}>
                {props.error.message}
                {props.error.data?.link && (
                    <HybridLink className={Styles['learn-link']} to={props.error.data.link}>
                        Learn more
                    </HybridLink>
                )}
            </div>
        </div>
    </div>
));

ErrorDetailsView.displayName = 'ErrorDetailsView';

export default ErrorDetailsView;
